import { render, staticRenderFns } from "./ModalAlertConfirm.vue?vue&type=template&id=3812d415"
import script from "./ModalAlertConfirm.vue?vue&type=script&lang=js"
export * from "./ModalAlertConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports